import { render, staticRenderFns } from "./productAttributes.vue?vue&type=template&id=2c2f48e4&scoped=true"
import script from "./productAttributes.vue?vue&type=script&lang=js"
export * from "./productAttributes.vue?vue&type=script&lang=js"
import style0 from "./productAttributes.vue?vue&type=style&index=0&id=2c2f48e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f48e4",
  null
  
)

export default component.exports